<template>
  <div class="psr" :class="{ 'psr--readonly': readonly }">
    <button
      v-for="star in max"
      :key="star"
      type="button"
      class="psr__star"
      :disabled="readonly"
      :aria-label="star + ' of ' + max"
      @click="$emit('input', star)"
    >
      <v-icon :size="size" class="psr__icon" :class="{ 'psr__icon--on': star <= value }">
        {{ star <= value ? 'bhi-star-filled' : 'bhi-star-empty' }}
      </v-icon>
    </button>
  </div>
</template>

<script>
// Mobile's ACTIVITY_MAX_RATING (mobile/src/configs/constants) and the backend's
// ExerciseRating schema both cap the scale at 5.
const MAX_RATING = 5

/**
 * Star scale used for both the per-action and the per-day rating on the client-facing Positive
 * Actions page. Mirrors the mobile `RatingSelect` atom.
 */
export default {
  name: 'StarRating',
  props: {
    value: { type: Number, default: 0 },
    readonly: { type: Boolean, default: false },
    size: { type: Number, default: 20 },
  },
  data() {
    return { max: MAX_RATING }
  },
}
</script>

<style lang="scss" scoped>
.psr {
  display: flex;
  align-items: center;

  &__star {
    background: none;
    border: none;
    padding: 0 2px;
    cursor: pointer;
    line-height: 1;
    &:disabled {
      cursor: default;
    }
  }
  &__icon {
    color: #dbdde0 !important;
    &--on {
      color: #fac032 !important;
    }
  }
}
</style>
